import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Login from '@/components/Login/Login';
import Dashboard from '@/components/Dashboard';
/* User */
import ListUser from '@/components/User/ListUser'
import AddUpdateUser from '@/components/User/AddUpdateUser'
import AddUpdateUserProfile from '@/components/User/AddUpdateUserProfile'

/* Class */
import AddUpdateClass from '@/components/Class/AddUpdateClass'
import ClassCalender from '@/components/Class/ClassCalender'
import ListUpcomingClass from '@/components/Class/TabView/ListUpcomingClass'
import ListAttandentClass from '@/components/Class/TabView/ListAttandentClass'
import TabView from '@/components/Class/TabView/TabView'
import CommonClassDetailPage from '@/components/CommonModelForClass/CommonClassDetailPage'
/* Class Master */
import AddUpdateClassMaster from '@/components/ClassMaster/AddUpdateClassMaster'
import ListMasterClass from '@/components/ClassMaster/ListMasterClass'


import Test from '@/components/Test';

Vue.use(Router);

export default new Router({
	mode: 'history',
  	routes: [
		{
            path: '/',
            name: 'Login',
            component: Login
		},
		{
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/list-user',
            name: 'ListUser',
            component: ListUser
        },
        {
            path: '/add-user',
            name: 'AddUser',
            component: AddUpdateUser
        },
        {
            path: '/update-user/:id',
            name: 'UpdateUser',
            component: AddUpdateUser
        },
        {
            path: '/update-profile',
            name: 'AddUpdateUserProfile',
            component: AddUpdateUserProfile
        },
        {
            path: '/test',
            name: 'Test',
            component: Test
        },
        {
            path: '/add-class',
            name: 'AddClass',
            component: AddUpdateClass
        },
        {
            path: '/update-class/:id',
            name: 'UpdateClass',
            component: AddUpdateClass
        },
        {
            path: '/class-master/list',
            name: 'ListMasterClass',
            component: ListMasterClass
        },
        {
            path: '/add-class-master',
            name: 'AddClassMaster',
            component: AddUpdateClassMaster
        },
        {
            path: '/update-class-master/:id',
            name: 'UpdateClassMaster',
            component: AddUpdateClassMaster
        },
        {
            path: '/class/calender',
            name: 'ClassCalender',
            component: ClassCalender
        },
        {
            path: '/upcomingclass/list',
            name: 'ListUpcomingClass',
            component: ListUpcomingClass
        },
        {
            path: '/attandentclass/list',
            name: 'ListAttandentClass',
            component: ListAttandentClass
        },
        {
            path: '/class/tabview',
            name: 'ListClass',
            component: TabView
        },
        {
            path: '/class/details',
            name: 'CommonClassDetailPage',
            component: CommonClassDetailPage,
            props: true
        },
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js